import { sitesApi } from "@/services/api/sites.api";
import appSnackbarService from "@/services/appSnackbar.service";
import i18n from "@/services/i18n";

interface SiteRequest {
  sortBy: string;
  descending: string;
  page: number;
  rowsPerPage: number;
  searchString: string[];
}

interface SitePost {
  data: object;
  index: number;
}

interface SiteDelete {
  id: number;
  index: number;
}

export const sitesState: any = {
  namespaced: false,
  state: {
    sites: [],
    totalItem: 0,
    total: 0,
    loading: true,
    fetching: false
  },
  mutations: {
    // load sites
    SITE_FETCH_SUCCESS(state: any, payload: any) {
      state.sites = payload.data;
      state.total = payload.data.length;
      state.totalItem = payload.totalCount;
      state.loading = false;
      state.fetching = false;
    },
    SITE_FETCH_START(state: any) {
      state.fetching = true;
    },
    SITE_FETCH_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
    },

    // save
    SITE_SAVE_SUCCESS(state: any, payload: any) {
      if (payload.index > -1) {
        // update
        // letörli a (payload.index)-ű elemet
        state.sites.splice(payload.index, 1, payload.data);
      } else {
        // add
        state.sites.push(payload.data);
      }
    },
    SITE_SAVE_START(state: any) {
      state.fetching = true;
    },
    SITE_SAVE_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
    },

    // delete
    SITE_DELETE_SUCCESS(state: any, payload: any) {
      if (payload.index > -1) {
        // update
        state.sites.splice(payload.index, 1);
        state.loading = false;
      }
    },
    SITE_DELETE_START(state: any) {
      state.fetching = true;
      state.loading = true;
    },
    SITE_DELETE_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
      state.loading = false;
    },
  },
  actions: {
    getSites({ commit }: any, request: SiteRequest) {
      commit("SITE_FETCH_START");

      const promise = new Promise((resolve, reject) => {
        sitesApi
          .getAll(request)
          .then(response => {
            commit("SITE_FETCH_SUCCESS", response.data);
            resolve(response);
          })
          .catch(error => {
            commit("SITE_FETCH_ERROR", error);
            reject(error);
          });
      });
      return promise;
    },
    saveSite({ commit }: any, payload: SitePost) {
      commit("SITE_SAVE_START");
      const editedIndex = payload.index;

      const promise = new Promise((resolve, reject) => {
        sitesApi
          .save(payload.data)
          .then(response => {
            commit("SITE_SAVE_SUCCESS", {
              data: response.data,
              index: editedIndex
            });
            appSnackbarService.success(i18n.t("SUCCESS_MESSAGES.SITE_SAVED"));
            resolve(response);
          })
          .catch(error => {
            commit("SITE_SAVE_ERROR", error);
            // appSnackbarService.error(error);
            reject(error);
          });
        });
      return promise;
    },
    deleteSite({ commit }: any, payload: SiteDelete) {
      commit("SITE_DELETE_START");

      const deletedIndex = payload.index;
      sitesApi
        .delete(payload.id)
        .then(response => {
          commit("SITE_DELETE_SUCCESS", {
            data: response.data,
            index: deletedIndex
          });
          appSnackbarService.warning(i18n.t("SUCCESS_MESSAGES.SITE_DELETED"));
        })
        .catch(error => {
          commit("SITE_DELETE_ERROR", error);
          // appSnackbarService.error(error);
        });
    },
  }
};
